import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { MainContent } from './components'
import { useSelector } from 'react-redux'

const title = {
  en: 'Sign Up Your Organization',
  id: 'Daftarkan Organisasi Anda'
}

const RegisterOrganization = () => {
  const language = useSelector(state => state.system.language)

  return (
    <DefaultLayout>
      <SimplePageHeader title={title[language.name]} largePadding />
      <MainContent />
    </DefaultLayout>
  )
}

export { RegisterOrganization }
